import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: '',
    backButton: 'mb-8 h-auto',
    title: 'heading-2xl lg:heading-2xl-desk mb-2',
    description: 'heading-s mb-8',
    button: 'mt-12 w-full'
  }
});
